"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildChannelCardsDeeplinkUrl = exports.buildVideoCardsDeeplinkUrl = exports.getWidgetSettingsByInstanceId = exports.getWidgetSettings = exports.publicWidgetsService = void 0;
var widgets_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/widgets/widgets");
var to_error_1 = require("../../parsers/to-error");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
exports.publicWidgetsService = new widgets_1.PublicWidgets();
var getWidgetSettings = function (widgetId) {
    return exports.publicWidgetsService
        .getSettings(widgetId)
        .then(function (response) { return (0, object_1.keysToCamelCase)(response.data); })
        .catch(to_error_1.toError);
};
exports.getWidgetSettings = getWidgetSettings;
var getWidgetSettingsByInstanceId = function (instanceId) {
    return exports.publicWidgetsService
        .getSettingsByInstanceId(instanceId)
        .then(function (response) { return (0, object_1.keysToCamelCase)(response.data); })
        .catch(to_error_1.toError);
};
exports.getWidgetSettingsByInstanceId = getWidgetSettingsByInstanceId;
var buildVideoCardsDeeplinkUrl = function (_a) {
    var channelId = _a.channelId, videoId = _a.videoId, fallbackUrl = _a.fallbackUrl, instance = _a.instance;
    return exports.publicWidgetsService.buildVideoCardsDeeplinkUrl({
        host: hosts_1.PRODUCTION_HOSTS.catalog,
        channelId: channelId,
        videoId: videoId,
        fallbackUrl: fallbackUrl,
        instance: instance,
    });
};
exports.buildVideoCardsDeeplinkUrl = buildVideoCardsDeeplinkUrl;
var buildChannelCardsDeeplinkUrl = function (_a) {
    var channelId = _a.channelId, fallbackUrl = _a.fallbackUrl, instance = _a.instance;
    return exports.publicWidgetsService.buildChannelCardsDeeplinkUrl({
        host: hosts_1.PRODUCTION_HOSTS.catalog,
        channelId: channelId,
        fallbackUrl: fallbackUrl,
        instance: instance,
    });
};
exports.buildChannelCardsDeeplinkUrl = buildChannelCardsDeeplinkUrl;
//# sourceMappingURL=widgets.js.map